<template>
  <div class="chartbox-div-wrap">
    <span class="chartbox-span-title">
      {{ title }}
    </span>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ChartBox',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus">
.chartbox
  &-span-title
    display block
    margin-top 16px
    margin-left 16px
    margin-bottom 10px
    font-size 14px
    color #4a4a4a
</style>
